import { Component, OnInit } from '@angular/core';
import {languageNames} from './../../../models/dummy-data';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {TaxFormSupportiveLanguage} from '../../../models/tax-forms.model';
import {DialogService} from '@shared/services/dialog-service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {StorageSettings} from "../../../../translation/models/translation.constants";


@Component({
    standalone: false,
    selector: 'particle-form-grid-translation-dialog',
  templateUrl: './form-grid-translation-dialog.component.html',
  styleUrls: ['./form-grid-translation-dialog.component.scss'],
})
export class FormGridTranslationDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  taxformsSupportiveLanguage: TaxFormSupportiveLanguage[] = [];
  isFileScanned: boolean;
  toLanguage: string;
  translationId: string;
  storageSettings: string = 'Stored';
  storageOptions = StorageSettings;

  constructor(private snackBarService: SnackBarService) {
    this.isFileScanned = false;
    this.toLanguage = '';
  }
  ngOnInit() {
    this.translationId = this.data.input.translationId;
    this.taxformsSupportiveLanguage = this.data.input.taxformsSupportiveLanguage;
  }

  onOkClicked(): boolean {
    if (!this.toLanguage) {
      this.snackBarService.showError('Please select a language.');
      return;
    }
    this.data.input.translate = {
      toLanguage: this.toLanguage,
      isFileScanned: this.isFileScanned,
      storageSettings: this.storageSettings,
      storageOptions: this.storageOptions
    };
    return true;
  }
}
